// src/components/MapPicker.js
import axios from "../api/axiosInstance";
import React, { useState, useEffect } from "react";
import { GoogleMap, Marker } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "400px",
};

export default function MapPicker({
  lat,
  lng,
  onSelect
}) {

  const [position, setPosition] = useState({
    lat: lat || 28.6139,
    lng: lng || 77.2090,
  });


  useEffect(() => {

    if (lat && lng) {

      setPosition({
        lat: Number(lat),
        lng: Number(lng),
      });

    }

  }, [lat, lng]);



const getAddress = async (lat, lng) => {
  try {
    const res = await axios.get(
      `/reverse-geocode/?lat=${lat}&lng=${lng}`
    );

    if (res.data?.address) {
      return res.data.address;
    }

    return `${lat}, ${lng}`;
  } catch (error) {
    console.error("Reverse geocode failed:", error);
    return `${lat}, ${lng}`;
  }
};
  // ✅ When marker dragged
  const handleDragEnd = async (e) => {

    const newLat = e.latLng.lat();
    const newLng = e.latLng.lng();

    setPosition({
      lat: newLat,
      lng: newLng
    });

    const address = await getAddress(newLat, newLng);

    onSelect({
      address,
      lat: newLat,
      lng: newLng
    });

  };



  // ✅ NEW: When user clicks or touches map
const handleMapClick = (e) => {

  const newLat = e.latLng.lat();
  const newLng = e.latLng.lng();

  setPosition({
    lat: newLat,
    lng: newLng
  });

  if (e.placeId) {
    e.stop(); // IMPORTANT

    const service = new window.google.maps.places.PlacesService(
      document.createElement("div")
    );

    service.getDetails(
      {
        placeId: e.placeId,
        fields: ["name", "formatted_address"]
      },
      (place, status) => {

        if (
          status === window.google.maps.places.PlacesServiceStatus.OK
        ) {

          onSelect({
            address: place.name + ", " + place.formatted_address,
            lat: newLat,
            lng: newLng
          });

        }

      }
    );

  } else {

  getAddress(newLat, newLng).then((address) => {
    onSelect({
      address,
      lat: newLat,
      lng: newLng
    });
  });

}

};


  return (

    <GoogleMap
      mapContainerStyle={containerStyle}
      center={position}
      zoom={15}
      onClick={handleMapClick}   // ✅ IMPORTANT LINE
    >

      <Marker
        position={position}
        draggable
        onDragEnd={handleDragEnd}
      />

    </GoogleMap>

  );

}
